<template>
  <div class="news">
    <siteHeader />
    <div class="content">
      <div class="container">
        <page-breadcrumb :paths="['通知公告']" />

        <div class="page-content">
          <div class="left-nav">
            <h3>通知公告</h3>
            <ul>
              <li
                v-for="tab in tabs"
                :key="tab.name"
                :class="{ active: currentTab === tab.name }"
                @click="switchTab(tab.name)">
                {{ tab.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <h2>{{ currentTab }}</h2>
            <div class="news-list">
              <div
                v-for="news in newsList"
                :key="news.id"
                class="news-item"
                @click="viewNewsDetail(news)"
                @mouseenter="hoveredNews = news.id"
                @mouseleave="hoveredNews = null">
                <div class="news-content">
                  <h3 :class="{ hovered: hoveredNews === news.id }">
                    {{ news.title }}
                    <span class="new-tag" v-if="news.isNew">NEW</span>
                  </h3>
                  <p class="summary">{{ news.summary }}</p>
                  <div class="news-meta">
                    <span class="date">
                      <i class="far fa-calendar"></i>
                      {{ news.date }}
                    </span>
                    <span class="views">
                      <i class="far fa-eye"></i>
                      {{ news.views || 0 }} 阅读
                    </span>
                  </div>
                </div>
                <div class="news-more" :class="{ hovered: hoveredNews === news.id }">
                  <span class="read-more">阅读更多</span>
                  <i class="arrow-right"></i>
                </div>
              </div>
            </div>

            <!-- 分页器 -->
            <div class="pagination">
              <button :disabled="currentPage === 1" @click="changePage(currentPage - 1)" class="page-btn">
                上一页
              </button>
              <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
              <button
                :disabled="currentPage === totalPages"
                @click="changePage(currentPage + 1)"
                class="page-btn">
                下一页
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <siteFooter />
  </div>
</template>

<script>
import PageBreadcrumb from "@/components/Breadcrumb.vue";
import siteHeader from "../components/SiteHeader.vue";
import siteFooter from "../components/SiteFooter.vue";

export default {
  name: "NoticeView",
  components: {
    "page-breadcrumb": PageBreadcrumb,
    siteHeader,
    siteFooter,
  },
  data() {
    return {
      currentTab: "通知公告",
      hoveredNews: null,
      currentPage: 1,
      totalPages: 3,
      tabs: [{ name: "通知公告" }],
      newsList: [
        {
          id: 1,
          title: "两分钟带你详细了解消防设施操作员（中级）",
          date: "2024-01-24",
          summary:
            "消防设施操作员（中级）国家职业入级职业资格证书，全国通用，市场需求量很大，消防设施操作员主要从事消防设施巡查维护和消防技术服务的相关工作。",
          views: 156,
          isNew: true,
        },
        {
          id: 2,
          title: "重庆市长质良智检查高层建筑消防安全突出问题专项整治工作",
          date: "2024-01-24",
          summary:
            "12月22日，重庆市委副书记、市长廖良智到江北中区，检查高层建筑消防安全突出问题专项整治工作落实情况。",
          views: 89,
        },
        {
          id: 3,
          title: "国家开启消防安全三年整治",
          date: "2024-01-24",
          summary: "拓诚职业培训学校表示，随人类社会的发展，消防安全是国家专项治理的重中之重。",
          views: 245,
          isNew: true,
        },
        {
          id: 4,
          title: "考证考板啦！深度解析2020年消防设施操作员职业前景",
          date: "2024-01-24",
          summary: "2019年，人社部和应急管理部共同制定发布了消防设施操作员职业标准。",
          views: 167,
        },
        {
          id: 5,
          title: "这样做企业档案管理，包在板凳室",
          date: "2024-01-24",
          summary: "企业档案管理是一项重要工作，需要专业的知识和技能。",
          views: 98,
        },
      ],
    };
  },
  methods: {
    switchTab(tabName) {
      this.currentTab = tabName;
    },
    viewNewsDetail(news) {
      // 这里可以添加查看新闻详情的逻辑
      console.log("查看新闻:", news.title);
    },
    changePage(page) {
      this.currentPage = page;
    },
    getData() {},
  },
};
</script>

<style scoped>
.content {
  padding: 20px 0;
  min-height: calc(100vh - 60px);
  background: #f5f5f5;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #1e88e5;
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.left-nav li:hover {
  background: #e3f2fd;
  color: #1e88e5;
}

.left-nav li.active {
  background: #1e88e5;
  color: white;
}

.right-content {
  flex: 1;
  background: white;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.news-item {
  display: flex;
  align-items: center;
  padding: 25px;
  border-bottom: 1px solid #eee;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.news-item:hover {
  background: #f8f9fa;
  transform: translateX(5px);
}

.news-item:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: #1e88e5;
  opacity: 0;
  transition: opacity 0.3s;
}

.news-item:hover:before {
  opacity: 1;
}

.news-content {
  flex: 1;
}

.news-content h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}

.news-content h3.hovered {
  color: #1e88e5;
}

.new-tag {
  background: #ff4081;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  margin-left: 10px;
}

.summary {
  color: #666;
  margin: 0 0 12px 0;
  line-height: 1.6;
}

.news-meta {
  display: flex;
  gap: 20px;
  color: #999;
  font-size: 14px;
}

.news-meta i {
  margin-right: 5px;
}

.news-more {
  display: flex;
  align-items: center;
  color: #999;
  transition: all 0.3s;
}

.news-more.hovered {
  color: #1e88e5;
}

.read-more {
  margin-right: 10px;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s;
}

.news-item:hover .read-more {
  opacity: 1;
  transform: translateX(0);
}

.arrow-right {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: rotate(45deg);
  transition: transform 0.3s;
}

.news-item:hover .arrow-right {
  transform: rotate(45deg) scale(1.2);
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #1e88e5;
  background: white;
  color: #1e88e5;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.page-btn:hover:not(:disabled) {
  background: #1e88e5;
  color: white;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: #666;
}

@media screen and (max-width: 768px) {
  .content {
    padding: 12px 0;
    min-height: auto;
  }

  .page-content {
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
  }

  .left-nav {
    width: 100%;
    padding: 12px;
  }

  .left-nav ul {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .left-nav li {
    flex-shrink: 0;
    white-space: nowrap;
    padding: 8px 12px;
  }

  .right-content {
    padding: 16px;
  }

  .news-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 12px;
  }

  .news-item:hover {
    transform: none;
  }

  .news-content h3 {
    font-size: 16px;
  }

  .news-meta {
    flex-wrap: wrap;
    gap: 8px;
    font-size: 12px;
  }

  .news-more {
    display: none;
  }

  .pagination {
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
